import { Observable,Subscription,Subject,forkJoin,of } from 'rxjs';
import { map,tap,flatMap,share,debounceTime, take } from 'rxjs/operators';

import { Vasat,VasatModel,VasatSearchQuery,SearchResults,User,VasatSession,VasatModelClass, Role} from "vasat"

import { Account, Dataset,DatasetGroup,Folder,DatasetType,Transform,TransformType,Annotation,
  EPSGCodes,PlottableModel,Project,ProcessorAPI,AccountPlan,JobType,Job,JobBatch,Tag, Widget} from './4d-objects'

import { ServerProcess, ChunkedFileUploader } from './4d-processor.service'

/**
 * <p>Interface that outlines common properties of a processing task event.</p>
 */
export interface TaskEvent{
  event:string
  task:ServerProcess
  finished:boolean
  error:boolean
}

/* TODO: update links to Vasat documentation. (find and replace: linkToVasat ) */

/**
 * <p>Service containing useful methods to communicate with server.</p>
 */
export class FourDService{


  playground:Dataset[] = []

  FILTER_PLOTABLE = "plotable"

  FILE_UPLOADED = "file_uploaded"
  FILE_FAILED = "file_failed"
  FILE_CNX = "file_cnx"
  FILE_ADDED = "file_added"
  FILE_BEFORE_UL = "file_before"
  FILE_PROGRESS = "file_prog"

 
  teams:Account[]

  domainConfig:any
 // account:Account

  domain:Account

  sampleAccount:Account

  rootAccounts:Account[]

  activeTeam:Account
  activeUser:User

  activeWidgets:Widget[] = []


  datasetTypes:DatasetType[]
  transformTypes:TransformType[]

  plans:AccountPlan[]

  projects:Project[]

  apis:ProcessorAPI[]


  jobTypes:JobType[]

  tags:Tag[]

  filters = {}

  activeDataset:Dataset

  uploadChunkSize:number = 5000000

  runningTasks:ServerProcess[] = []
  runningTasksMap:{[datasetId:string]:ServerProcess} = {}
  
  uploadsRunning:ServerProcess[] = []
  uploadsRunningMap:{[id:string]:ServerProcess} = {}

  uploadsQueued:ServerProcess[] = []
  uploadsQueuedMap:{[id:string]:ServerProcess} = {}

  roles:Role[]

  testing:string

  private _runningTaskSubject = new Subject<TaskEvent>()
  runningTasksObservable:Observable<TaskEvent>   = this._runningTaskSubject.asObservable()

  private _uploadsRunningSubject = new Subject<TaskEvent>()
  uploadsRunningObservable:Observable<TaskEvent>   = this._uploadsRunningSubject.asObservable()


  private _accountChangeSubject = new Subject<Account>()
  accountChangeObservable:Observable<Account>  = this._accountChangeSubject.asObservable()

  private _activeAccountObservable:Observable<Account>
  private _accountsObservale:Observable<Account[]>
  
  private _socketSubject:Subject<any> = new Subject()
  private _socketObservable:Observable<any> = this._socketSubject.asObservable().pipe(debounceTime(30000))
  
  private _socketCommands = {}

  private socket:WebSocket
 
  constructor(public V:Vasat){
  
    // debug
    this._socketObservable.subscribe((item) => console.log(item))

    this.onSocketCommand('welcome').subscribe(s => 
      s.running.forEach(i => {
        if(i.lastProgress){
          var v = new ServerProcess()
          Object.keys(i.lastProgress).forEach(k => v[k] = i.lastProgress[k])
          this.addTask(v)
        }
      })
    )
  }

  /**
   * <p>Logout of current user.</p>
   */
  logout(){
    return this.V.logoutObservable().pipe(
      map(s => 
        this.clearStates()
      )
    )
  }


  /**
   * <p>Removes active team.</p>
   */
  clearStates(){
    this.teams = null
    this.activeTeam = null
    this.activeUser = null
    this._accountsObservale = null
    this.deinitSocket()
  }


  onV2Init(){
    return this.onReady().pipe(flatMap(res => {

      if(!this.datasetTypes){
        return this.V.searchByObject(TransformType).useCache(true).limit(101).queryObservable()
              .pipe(
                flatMap((t) => {
                  this.transformTypes = t.items
                  return this.V.searchByObject(DatasetType).useCache(true).limit(102).queryObservable()
                }),
                flatMap(ds => {
                  this.datasetTypes = ds.items;
                  this.filters[this.FILTER_PLOTABLE] = this.datasetTypes.filter(d => d.canPlot)
                  return forkJoin(
                    this.V.searchByObject(ProcessorAPI).useCache(true).equals('active',true).queryObservable().pipe(
                      map((t) => 
                        this.apis = t.items
                      )
                    ),
                    this.V.searchByObject(JobType).useCache(true).equals('active',true).queryObservable().pipe(
                      map((t) => 
                        this.jobTypes = t.items
                      )
                    
                  ))
                  // map transforms to the local instance
                  //ds.items.forEach(dsi => {
                  //  dsi.adhocTransforms = dsi.adhocTransforms.map(t => this.transformTypes.find(tt =>  tt.id == t.id))
                  //  dsi.autoApplyTransforms = dsi.autoApplyTransforms.map(t => this.transformTypes.find(tt => tt.id == t.id))
                  //})
                })
              )
      }
      else{
        of(res)
      }
    }))
  }
  getQuotas(){
    return this.V.api('/api/Account/' + this.activeTeam.id + '?quota=true')
  }

  /**
   * <p>Returns an observable of an [[Account]] object. If it does not have a team or get sample [[Account]].</p>
   * <footer>Note: throws exception if not logged in.</footer>
   */
  onReady():Observable<Account[]>{
    
    if(this.teams){
      return of(this.teams)
    }
    else if(this._accountsObservale){
      return this._accountsObservale
    }
    else{
      return this._accountsObservale = this.V.onReady().pipe(
        flatMap(s => {
         
         this.activeUser = s?s.user:null
         if(!s){
            this.clearStates()
            throw "Not logged in"
         }
         else{
            if(!this.socket)
              this.initSocket(s)

          
            this.onSocketCommand('update_dataset').subscribe(tc => {
              var ds = this.V.findCached(Dataset,tc.id)
              if(ds)
                ds.set(tc)
            })

            this.onSocketCommand('task_update').subscribe(tc => {
              let task:ServerProcess = this.runningTasksMap[tc.dataset.id]
              var isFinished = tc.status == 'finished' || tc.status == 'error'
                
              if(task){
                task.update(tc)
               
                if(isFinished)
                  this.removeTask(tc,tc.status == 'error')
                else
                  this._runningTaskSubject.next({
                    event:'update',
                    task:task,
                    finished:isFinished,
                    error: tc.status == 'error'
                  })
              }
              else if(!isFinished){
                let t = new ServerProcess()
                t.update(tc)
                this.addTask(t)
              }
            })
            return forkJoin([
                this.V.searchByObject(AccountPlan).useCache(true).equals('active',true).queryObservable().pipe(
                  map((t) => 
                    this.plans = t.items
                  )
                ),
                this.V.searchByObject(Role).useCache(true).equals('active',true).limit(104).queryObservable().pipe(
                  map((t) => 
                    this.roles = t.items
                  )
                ),
                this.V.api("/4dinfo").pipe(tap(config => this.domainConfig = config)),
                this.V.searchByObject(Account).useCache(true).limit(105).queryObservable().pipe(
                  map(r => {
                
                    this._accountsObservale = null

                    this.V.registerCacheClass(Account,r.items)
                    this.V.registerClass(Dataset)
                    this.V.registerClass(JobType)
                    this.V.registerClass(Job)
                    this.V.registerClass(JobBatch)
                    this.V.registerClass(DatasetType)
                    this.V.registerClass(Transform)
                    this.V.registerClass(Project)
                    this.V.registerClass(TransformType)
                    this.V.registerClass(Annotation)
                    //this.V.registerClass(Widget)
                    this.V.registerClass(EPSGCodes)

                    this.domain = r.items.find(a => a.isDomain)
                    this.rootAccounts = r.items.filter(a => !a.parent && a.uid != 'sample' && !a.closed)
                    this.sampleAccount = r.items.find(a => a.uid == 'sample' && a.active)
                    
                    return this.teams = <any>r.items.filter(a => a.uid != 'sample')
                  })
                )
            ])
         }
      }),
        share()

        )
      
    }

  }

  /**
   * <p>If [[ServerProcess]] is not already running, add it. Otherwise update it.</p>
   * @param t The [[ServerProcess]] to add.
   */
  addTask(t:ServerProcess){
  
    if(this.runningTasksMap[t.dataset.id]){
     
      t = this.runningTasksMap[t.dataset.id].update(t)
    }
    else{
      this.runningTasks.push(t)
      this.runningTasksMap[t.dataset.id] = t
      this._runningTaskSubject.next({
        event:'add',
        task:t,
        finished:false,
        error:false
      })
    }

  }

  /**
   * Remove the [[ServerProcess]] task.
   * @param task The task to remove.
   * @param err if the task ended in error set to true.
   */
  removeTask(task:ServerProcess,err?:boolean){
    delete this.runningTasksMap[task.dataset.id]
    this.runningTasks = this.runningTasks.filter(t => t.dataset.id != task.dataset.id)

    this._runningTaskSubject.next({
        event:'remove',
        task:task,
        finished:true,
        error:!!err
    })
  }


  /**
   * <p>Uploads file using [[ChunkedFileUploader]].</p>
   * @param ds [[Dataset]] to upload associated file.
   * @param f File to be uploaded.
   * @param filename Name of file.
   * @param chunkSize Size of chunks when uploading.
   */
  uploadFile(ds:Dataset,f:File, filename:string = 'data',chunkSize?:number){
     var c = new ChunkedFileUploader(this.V,this.V.config.host + '/api/Dataset/' + ds.id + '.chunked/' + filename,chunkSize || this.uploadChunkSize)
     c.fileRef = f

     var task = new ServerProcess()
     task.dataset = ds
     task.uid = '' + ds.id
     task.status = 'uploading'
     task.name = 'UPLOAD'
     task.progress = ds.incomplete?ds.incomplete_offset / ds.incomplete_total:0
     task.uploader = c

     var sub = c.progressObservable.subscribe(s => 
       task.progress = s
     )

     this.uploadsQueued.push(task)
     this.uploadsQueuedMap[task.dataset.id] = task
     setTimeout(() => this._deQueue(),100)
     return task
  }
  
  _deQueue(){
    if(this.uploadsRunning.length < 4 && this.uploadsQueued.length){
      var next = this.uploadsQueued[0]

      var queue = next.uploader.uploadObservable(next.uploader.fileRef,
        next.dataset.incomplete?next.dataset.incomplete_offset:0,
        next.dataset.incomplete?next.dataset.incomplete_seq:0)

      this.uploadsRunning.push(next)
      this.uploadsRunningMap[next.dataset.id] = next
      

      this.uploadsQueued = this.uploadsQueued.filter(q => q != next)
      delete this.uploadsQueuedMap[next.dataset.id] 
      
      this._uploadsRunningSubject.next({
        task:next,
        finished:false,
        event:'start',
        error:false
      })

      queue.subscribe(s => {
          var me = this.uploadsRunning.find(u => u.uploader == s.chunk)
          this.uploadsRunning = this.uploadsRunning.filter(r => r != me)

          delete this.uploadsRunningMap[me.dataset.id]

          this._uploadsRunningSubject.next({
            task:me,
            finished:true,
            event:'finished',
            error:false
          })
          this._deQueue()
        },
        e => {
          var me = this.uploadsRunning.find(u => u.uploader == next.uploader)
          this.uploadsRunning = this.uploadsRunning.filter(r => r != me)
          delete this.uploadsRunningMap[me.dataset.id]
          if(me.error && e.error)
              me.error(e.error)
            
          this._uploadsRunningSubject.next({
            task:me,
            finished:true,
            event:'error',
            error:true
          })

          this._deQueue()
        }
      )
    }
  }

  /**
   * <p>Queries for <a href="https://docs.vasat.io/">Vasat</a> Model class and returns a <a href=" linkToVasat ">VasatSeachQuery</a>.</p>
   * @param objectType The Vasat model you want to query for.
   */
  searchFor<T extends PlottableModel<T>>(objectType:VasatModelClass<T>) {
    return this.V.searchByObject(objectType)
  }
  
  /**
   * <p>Returns observable of [[Account]] if it exists. Else throws exception.</p>
   */
  onActiveAccountReady():Observable<Account>{

    if(this._activeAccountObservable)
      return this._activeAccountObservable
    else  if(this.activeTeam){
      return of(this.activeTeam)
    }
    else
      return this.accountChangeObservable.pipe(take(1))

  }
   

  tryingAccount:string
  
  /**
   * <p>Note that this is for advanced users with multiple teams. If you are a single user this does not apply.</p>
   * <p>Sets the active team to given accountId, so all subsequent api calls that are made will return things that only this accountId can see.</p>
   * @param accountId 
   */
  setActiveTeam(accountId:string):Observable<Account>{
    
    this.tryingAccount = accountId

    this.V.registerCacheClass(TransformType,[])
    this.V.registerCacheClass(DatasetType,[])

    if(this.activeTeam && this.activeTeam.uid == accountId){
    
      return of(this.activeTeam)
    }
    else if(!accountId){
      this.V.pathPrefix = '/api'
      this.activeTeam = null
      this._activeAccountObservable = null
      return of(this.activeTeam)
    }
    else if(this._activeAccountObservable){
    
      return this._activeAccountObservable

    }
    else{
    
      return this._activeAccountObservable = this.onReady().pipe(
        flatMap(aa => {

          let res = aa.find(a => a.uid == accountId)
          
          if(res){
          
            this.activeTeam = res
            
            this.V.pathPrefix = '/app/Account/' + accountId + '/api'
            console.log("Active Account Set Prefix " + this.V.pathPrefix)

            // load the transform types first then the dataset types
            return this.V.searchByObject(TransformType).useCache(true).limit(106).queryObservable()
              .pipe(
                flatMap((t) => {
                  this.transformTypes = t.items
                  return this.V.searchByObject(DatasetType).useCache(true).limit(107).queryObservable()
                }),
                map(ds => {
                  this.datasetTypes = ds.items;
                  this.filters[this.FILTER_PLOTABLE] = this.datasetTypes.filter(d => d.canPlot)
                  return ds.items
                  // map transforms to the local instance
                  //ds.items.forEach(dsi => {
                  //  dsi.adhocTransforms = dsi.adhocTransforms.map(t => this.transformTypes.find(tt =>  tt.id == t.id))
                  //  dsi.autoApplyTransforms = dsi.autoApplyTransforms.map(t => this.transformTypes.find(tt => tt.id == t.id))
                  //})
                }),
                flatMap(_ => {
              
                  return this.V.searchByObject(Tag).useCache(true).limit(108).queryObservable().pipe(tap(res => this.tags = res.items))
                }),flatMap(_ => {
                  var obsList:Observable<any>[] = [
                    this.V.searchByObject(ProcessorAPI).useCache(true).equals('active',true).queryObservable().pipe(
                      map((t) => 
                        this.apis = t.items
                      )
                    ),
                    this.V.searchByObject(JobType).useCache(true).equals('active',true).queryObservable().pipe(
                      map((t) => 
                        this.jobTypes = t.items
                      )
                    ),
                    this.V.searchByObject(Project).useCache(true).equals('active',true).limit(109).queryObservable().pipe(
                      map((t) => 
                        this.projects = t.items
                      )
                    )
                  ]
                  // Check if account has plan
                  if (this.activeTeam.plan) {
                    obsList.push(
                      this.activeTeam.plan.availableWidgets.useCache(true).equals('active',true).limit(110).queryObservable().pipe(
                        map((t) => 
                          this.activeWidgets = t.items
                        )
                      )
                    )
                  }

                  return forkJoin(obsList)
                }),
                map(done => {
                  this._accountChangeSubject.next(res)
                  this._activeAccountObservable = null
                  return res
                })
              )
        
          }
          else{
            this.V.pathPrefix = '/api'
            throw "Invalid account ID " + accountId
          }
        
        }),
        share()
      )
      
    }
  }



  socketUp:boolean
  /**
   * <p>Initialise WebSocket.</p>
   * @param s 
   */
  initSocket(s:VasatSession){
    if(this.socket) return
    try{  
      this.runningTasks = []
      this.runningTasksMap = {}

      this.socket = new WebSocket(this.V.config.host
       .replace('https://','wss://')
       .replace('http://','ws://') + "/socket?access_token=" + s.access_token
       )

      this.socket.onopen = (ev) => this.socketUp = true

      this.socket.onmessage = (ev) => {
       try{
         let obj = JSON.parse(ev.data)
         this._socketSubject.next(obj)
         if(obj.cmd && this._socketCommands[obj.cmd]){
           this._socketCommands[obj.cmd].subject.next(obj.payload)
         }
         if(this._socketCommands['*']){
           this._socketCommands['*'].subject.next(obj.payload)
         }
         if(this._socketCommands['*!']){
          this._socketCommands['*!'].subject.next(obj)
         }
       }
       catch(e){
         this._socketSubject.error(e)
       }
      }

      this.socket.onerror = (ev) => {
       this.retrySocket(s,ev)
      }

      this.socket.onclose = (ev) => {
       this.retrySocket(s,ev)
      }
   }catch(e){
    
     this.retrySocket(s,e)
    
   }

  }

  /**
   * <p>Try to reinitialise WebSocket.</p>
   * @param s An active <a href=" linkToVasat ">Vasat Session</a>.
   * @param e Error or exception.
   */
  retrySocket(s:VasatSession,e){
     this.socket = null
     this.socketUp = false
     this._socketSubject.error(e)
     setTimeout(() => this.initSocket(s),10000)
  }

  /**
   * <p>Close WebSocket.</p>
   */
  deinitSocket(){
    if(this.socket){
       this.socket.close()
       this.socket = null
       this.socketUp = false
    }
  }

    /**
     * <p>If command does not exist, create one and return.</p>
     * @param cmd Socket command.
     */
    onSocketCommand(cmd:string):Observable<any>{
        let obj = this._socketCommands[cmd]
        if(!obj){
          let subj = new Subject<any>()
          let obs = subj.asObservable()//.pipe(debounceTime(30000))
          obj = {subject:subj,obs:obs}
          this._socketCommands[cmd] = obj
        }
        return obj.obs
    }

    /**
     * <p>Transmist data to server.</p>
     * @param a Data to send.
     */
    sendSocket(a:any){
        if(this.socket)
          if(typeof a == "string")
            this.socket.send(a)
          else
            this.socket.send(JSON.stringify(a))
        else
        console.error("Socket closed for sending " + a)
    }

    /**
     * <p>Return [[ProcessorAPI]] of given type.</p>
     * @param apiType The type of transformation from this API.
     */
    getApi(apiType:string):ProcessorAPI {
        return this.apis.find(ele => ele.type == apiType)
    }

    /**
     * 
     * @param folderId retun the chain of folders going up to the root folder for the specified folder Id
     */
    getFolderChain(folderId:number, cache:boolean = true):Observable<Folder[]>{
      return this.V.searchByObject(Folder).equals("chainBy",folderId).useCache(cache).queryObservable().pipe(map(s => {
        if(s.items.length){
          var base = s.items.find(ff => ff.id == folderId)
          var f = base
          var chain = [base]
          while(f.parent){
            f = s.items.find(ff => ff.id == f.parent.id)
            chain.push(f)
          }
          return chain
       }
    }))
  }

}



/**
 * <p>Base component class to extend that initialises common properties, and calls [[onReady]] when initialising is finished.</p>
 */
export class BaseComponent{

    loading:boolean = false
    sub:Subscription
    activeUser:User

    constructor(protected _4D:FourDService, private _account:string = null){
        
    }

    /**
     * <p>Initialises some properties that will be commonly used among your components.</p>
     */
    ngOnInit(){
     
        this.sub = this._4D.onReady().pipe(
          flatMap(aa => {
            if(this._account)
              return this._4D.setActiveTeam(this._account)
            else if(this._4D.tryingAccount)
              return this._4D.onActiveAccountReady()
            else 
              return of(aa[0])
          })
        ).subscribe(s => {
          let ls = this._4D.V.localSession()
          this.activeUser = ls ? ls.user : null
          this.onReady()
        })
       
    }

    /**
     * <p>This is called when initialisation has finished. Your components should do their initialisation here.</p>
     */
    onReady(){

    }
   
    /**
     * <p>Unsubscribes from subscription when component destroyed.</p>
     */
    ngOnDestroy(){
       
        this.sub.unsubscribe()
    }
    
}